import React from "react";
import "../Styles/NavBar.css";

const NavBar = () => {
  return (
    <section>
      <div
        className="container-fluid text-center"
        style={{
          background:
            "linear-gradient(180deg, #032044 -105.93%, rgba(3, 57, 124, 0.892717) 79.63%, rgba(3, 115, 255, 0.77) 271.49%, rgba(0, 62, 139, 0) 331.11%)",padding:"1px 0"
        }}
      >
        <span
          style={{
            color: "white",
            fontSize: "12px",
            fontWeight: "normal",
            letterSpacing: "1.5px",
            fontFamily:"Work Sans"
          }}
        >
          FREE SHIPPING |
          <span style={{ fontWeight: "normal", letterSpacing: "1.3px" }}>
            {" "}
            Shop Now for Best Price
          </span>
        </span>
      </div>
      <nav className="navbar navbar-light bg-light">
        <div className="container-fluid d-flex flex-column justify-content-center">
          <a href="/" className="text-align-center">
            <img src="Images/Logo.png" alt="" className="logo" />
          </a>
          <span className="brand-text" style={{fontFamily:"Work Sans"}}>
            A <span >BRAND</span> BY{" "}
            <span
              style={{ fontFamily: "ARB", color: "#289e4f" }}
              className="empire-text"
            >
              EMPIRE
            </span>{" "}
            FOOTWEAR
          </span>
        </div>
      </nav>
    </section>
  );
};

export default NavBar;
